export default __webpack_public_path__ + "images/3a380a294b6787318b423c605cfc728d.png";